





















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  public sendTo(destination: string): void {
    this.$router.push('administration/' + destination);
  }
}
